import "../../eshop/ui/list";
import "../../eshop/ui/views";
import "../../eshop/ui/search";
import "../../eshop/ui/sidebar_active";
import "./cart/cart";
import "./floating_cart/cart";
import "./cart/guest_cart";
import "./cart/guest_cart_merge";
import "./cart/focus";
import "./cart/price_rule_bubble";
import "./cart/login_eshop_link";
import "./cart/login_signup_heading";

frappe.provide("ioi_partners")

// Shared guest test for the e-shop scripts. frappe.session is built from the
// user_id cookie (frappe/website/js/website.js), but only once its page-change
// handler has run, so the cookie is read directly when session is not set yet.
// Called at use time, never at import time, so bundle order does not matter.
ioi_partners.is_guest = () => {
	const user = (frappe.session && frappe.session.user) || frappe.get_cookie("user_id")
	return !user || user === "Guest"
}

// The e-shop language as one of its four codes, for scripts that would otherwise read
// frappe.boot.user_language. That value exists only where a page sets it
// (subscription.html) and is the raw request language, which can be a regional variant
// (en-US, fr-CA). Folded and allowlisted like translate.get_eshop_language(): anything
// else is English.
const ESHOP_LANGUAGE_CODES = ["en", "fr", "nl", "de"]

ioi_partners.eshop_language_code = () => {
	const lang = (frappe.boot && frappe.boot.user_language) || "en"
	if (ESHOP_LANGUAGE_CODES.includes(lang)) {
		return lang
	}
	const parent = lang.split("-")[0]
	return ESHOP_LANGUAGE_CODES.includes(parent) ? parent : "en"
}